import { inject, Injectable } from '@angular/core';
import { Company, CompanyCreateDto, CompanyUpdateDto } from '@zayan-erp/home-building';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  #http = inject(ApiCallingV2Service);
  #toastr = inject(ToastrService);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readCompanies(): Observable<Company[]> {
    return this.#http.getData(`${this.baseUrl}/company`, { showLoader: true, showMessage: false });
  }

  createCompany(company: CompanyCreateDto): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/company`,
      { showLoader: true, showMessage: true, message: 'Company created successfully' },
      company
    );
  }

  updateCompany(company: CompanyUpdateDto): Observable<unknown> {
    return this.#http.putData(`${this.baseUrl}/company/${company.id}`, company, {
      showLoader: true,
      showMessage: true,
      message: 'Company updated successfully'
    });
  }

  deleteCompany(ids: string[]): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/company/bulk-delete`,
      { showLoader: true, showMessage: true, message: 'Companies deleted successfully' },
      ids
    );
  }

  getCompanyByCode(compCode: string): Observable<Company> {
    return this.#http.getData(`${this.baseUrl}/company/code/${compCode}`, { showLoader: true, showMessage: false });
  }

  upsertCompanies(companies: CompanyCreateDto[]): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/company/bulk-upsert`,
      { showLoader: true, showMessage: true, message: 'Companies added successfully' },
      companies
    );
  }
}
